/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc
 */

export const getTrackingUrlsRpc = {
  serviceName: 'com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc',
  rpcName: 'getTrackingUrls',
  auth: 'app',
  fingerprint: 'YqqiQ8vOeoaLMis0T4RO4pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const queryTrackingUrlsRpc = {
  serviceName: 'com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc',
  rpcName: 'queryTrackingUrls',
  auth: 'app',
  fingerprint: 'm-JXUPUnKznuVc0P0XfRFpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const queryTrackingUrlsPagedRpc = {
  serviceName: 'com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc',
  rpcName: 'queryTrackingUrlsPaged',
  auth: 'app',
  fingerprint: 'gYjPO_RFlwPUq6JPtMr2fpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDeletedTrackingUrlsRpc = {
  serviceName: 'com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc',
  rpcName: 'getDeletedTrackingUrls',
  auth: 'app',
  fingerprint: 'FGGSTOGDqdRPh--TPYVfsJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSocialMediaSitesRpc = {
  serviceName: 'com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc',
  rpcName: 'getSocialMediaSites',
  auth: 'app',
  fingerprint: 'KOby4KYgxDDjcAtndfGGk5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createTrackingUrlRpc = {
  serviceName: 'com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc',
  rpcName: 'createTrackingUrl',
  auth: 'app',
  fingerprint: '1XeIaGnwX1eIeKSexxRPGvCIJreSP3g5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteTrackingUrlRpc = {
  serviceName: 'com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc',
  rpcName: 'deleteTrackingUrl',
  auth: 'app',
  fingerprint: 'CwfEyV2xVC7LqjUadpeW7fCIJreSP3g5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const restoreTrackingUrlRpc = {
  serviceName: 'com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc',
  rpcName: 'restoreTrackingUrl',
  auth: 'app',
  fingerprint: '0TWKOoAtIGMH27wGh-szu_CIJreSP3g5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneTrackingUrlsForCampaignRpc = {
  serviceName: 'com.hubspot.tracking.url.builder.chirp.TrackingUrlBuilderRpc',
  rpcName: 'cloneTrackingUrlsForCampaign',
  auth: 'app',
  fingerprint: 'I0cZSIvry1Yl-2rQNr1Jd_CIJreSP3g5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};